import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/UnitList.css";

const AssetList = () => {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "";

  const [assets, setAssets] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  // Modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [assetToDelete, setAssetToDelete] = useState(null);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const response = await fetch(`${API_URL}list-assets.php`, {
          method: "POST", // Changed to POST as requested
        });
        const data = await response.json();
        if (data.status === true && Array.isArray(data.data)) {
          setAssets(data.data);
        } else {
          showToast("Failed to load assets", "error");
        }
      } catch (error) {
        showToast("Network error. Please try again.", "error");
      }
    };
    fetchAssets();
  }, [API_URL]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  const filteredAssets = assets.filter(
    (asset) =>
      asset.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      asset.description?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handleAddAsset = () => {
    navigate("/add-asset");
  };

  const handleDelete = (assetId) => {
    setAssetToDelete(assetId);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${API_URL}delete-asset.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: assetToDelete }),
      });
      const data = await response.json();
      if (data.status === true) {
        setAssets((prev) => prev.filter((a) => a.id !== assetToDelete));
        showToast("Asset deleted successfully", "success");
      } else {
        showToast("Failed to delete asset", "error");
      }
    } catch (error) {
      showToast("Network error. Please try again.", "error");
    }
    setShowDeleteModal(false);
    setAssetToDelete(null);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setAssetToDelete(null);
  };

  return (
    <div className="category-list-content">
      <div className="page-header">
        <div className="header-content">
          <h1>Asset List</h1>
          <p>Manage all company assets</p>
        </div>
        <button className="add-unit-button" onClick={handleAddAsset}>
          + Add New Asset
        </button>
      </div>

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by name or description..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="unit-list-table-container">
        <table className="unit-list-table">
          <thead>
            <tr>
              <th>Asset Name</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Purchase Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssets.map((asset) => (
              <tr key={asset.id}>
                <td>{asset.name}</td>
                <td>{asset.description}</td>
                <td>₹{parseFloat(asset.amount).toFixed(2)}</td>
                <td>{new Date(asset.purchase_date)?.toLocaleDateString()}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="action-btn edit"
                      onClick={() => navigate(`/edit-asset/${asset.id}`)}
                    >
                      Edit
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => handleDelete(asset.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>Are you sure you want to delete this asset?</p>
            <div className="modal-actions">
              <button className="modal-btn yes" onClick={confirmDelete}>
                Yes
              </button>
              <button className="modal-btn no" onClick={cancelDelete}>
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssetList;
